import axios from "axios";
import store from "../stateManagement/store";
import { HttpHeaders, requestType } from "../types";
import {Buffer} from 'buffer';
import { EnvironmentRegistry } from "./registry/environmentRegistry";
import {getAccessToken, getLob, logoutUser } from "./authenticationService";
import { decryptByte, encrypt } from "./encryptionService"
import { getAuthRefreshToken,  setAuthServiceAccessExpiry, setAccessTokenInContext } from "./salescodeAuthService";

async function handleNetworkRequest(requestPromise: Promise<any>): Promise<any> {
    try {
      
      const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
      const token = (await networkService.authState.getHttpEncryptionKey()) || sessionStorage.getItem("secureToken");
      // console.log("token",token)
      const response = await requestPromise;
      
      if(token && response.headers["content-type"] === "application/octet-stream"){//token and content type remove end toend
        const decryptedResponse = await decryptByte(new Uint8Array(response.data), new Uint8Array(Buffer.from(token, 'base64')));
        const parsedData = JSON.parse(decryptedResponse);
        return {
          ...response,
          data: parsedData
        };
      }else{
        const isBinaryData = response.data instanceof ArrayBuffer || response.data instanceof Uint8Array;
        const data = isBinaryData
          ? JSON.parse(new TextDecoder().decode(response.data))
          : response.data; 
        return {
          ...response,
          data: data
        };
    }
    } catch (error: any) {
      if (error.response.status && (error.response.status === 403 )) {
        // Unauthorized (token expired)
        const isLoggedIn = getAccessToken();
        if(isLoggedIn) // check if logoutUser() was executed before
            await logoutUser(true, false);
      }
      throw error;
    }
  }

  let isTokenRefreshing = false;
  let tokenRefreshSubscribers: (() => void)[] = [];

  async function refreshToken() {
    if (isTokenRefreshing) {
      return new Promise<void>((resolve) => {
        tokenRefreshSubscribers.push(resolve);
      });
    }
    isTokenRefreshing = true;
    let skipFinally= false;
  
    try {
      const res = await getAuthRefreshToken();
      if (res) {
        setAccessTokenInContext(res.accessToken);
        setAuthServiceAccessExpiry(res.accessTokenExpiresIn);
      }
    }catch(error :any){
        const isLoggedIn = getAccessToken();
        skipFinally =true;
        if(isLoggedIn) 
            await logoutUser(false ,true);
    } 
    finally {
      isTokenRefreshing = false;
      if(!skipFinally){
      tokenRefreshSubscribers.forEach((callback) => callback());
    }
    tokenRefreshSubscribers = [];   
    }
  }


function addSourceQueryParam(url: string){
    if(url.includes("?") && !url.includes("source=portal")){
        url += "&source=portal"
    }else if(!url.includes("source=portal")){
        url += "?source=portal"
    }
    return url;
}
function addnewQueryParam(url: string){
  if(localStorage.getItem("endToend") === "true" && url.includes("?") && !url.includes("gZipEncryption=true")){
      url += "&gZipEncryption=true"
  }else if(localStorage.getItem("endToend") === "true" && !url.includes("gZipEncryption=true")){
      url += "?gZipEncryption=true"
  }
  return url;
}

export async function OrderRatingPost(url:string,requestBody?: any, headers?: HttpHeaders): Promise<any> {
  const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
  if(localStorage.getItem("refreshToken") && sessionStorage.getItem("access_token")){
    headers = { Authorization: sessionStorage.getItem("access_token")!, ...headers}
  }
  return handleNetworkRequest(networkService.post(addSourceQueryParam(url), requestBody, headers));  
}

export async function checkAndRefreshTokenIfNeeded() {
  const tokenExpiry = localStorage.getItem("access_token_expiry");
  if( tokenExpiry && isTokenExpiringSoon(tokenExpiry)) {
      await refreshToken();
    }
}

 function isTokenExpiringSoon(expiryTime: string, secondsRemaining = 10): boolean {
  const currentTime = Date.now();                    
  const expiryTimeMillis = Number(expiryTime);         
  const thresholdTime = expiryTimeMillis - secondsRemaining * 1000; 
  return currentTime >= thresholdTime;
}

export async function ChannelkartNetworkPost(url:string,requestBody?: any, headers?: HttpHeaders, returnBlob?: boolean): Promise<any> {
    const serverUrl = EnvironmentRegistry.getServerUrl();
    const finalUrl = url.startsWith("https") ? url : serverUrl + url;
    await checkAndRefreshTokenIfNeeded(); 
    const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
    const token = (await networkService.authState.getHttpEncryptionKey())|| sessionStorage.getItem("secureToken");
    if(localStorage.getItem("refreshToken") && sessionStorage.getItem("access_token")){
      headers = { Authorization: sessionStorage.getItem("access_token")!, ...headers}
      if (token && finalUrl.includes(serverUrl) && localStorage.getItem("endToend") === "true" && (!headers || headers["Content-Type"] !== "multipart/form-data")) {
        headers = { "Content-Type": "application/octet-stream", ...(headers || {}) };
        if(requestBody){
          // requestBody = await networkService.encrypt(requestBody,token);
          requestBody = await encrypt(JSON.stringify(requestBody), token);
          
        }
      }
    }
    return handleNetworkRequest(axios.post(addnewQueryParam(addSourceQueryParam(finalUrl)), requestBody, {
      headers: {
        ...headers,
        lob: getLob()
      },
      ...(  localStorage.getItem("endToend") === "true" && { responseType: 'arraybuffer' }),
      ...(returnBlob && { responseType: 'blob' })
    }));
    
}

export async function ChannelkartNetworkPut(url: string, requestBody?: any, headers?: HttpHeaders): Promise<any> {
    const serverUrl = EnvironmentRegistry.getServerUrl();
    const finalUrl = url.startsWith("https") ? url : serverUrl + url;
    await checkAndRefreshTokenIfNeeded();
    const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
    const token = (await networkService.authState.getHttpEncryptionKey())|| sessionStorage.getItem("secureToken");;
    if(localStorage.getItem("refreshToken") && sessionStorage.getItem("access_token")){
      headers = { Authorization: sessionStorage.getItem("access_token")!, ...headers}
      if (token && finalUrl.includes(serverUrl) && localStorage.getItem("endToend") === "true" && (!headers || headers["Content-Type"] !== "multipart/form-data")) {
        headers = { "Content-Type": "application/octet-stream", ...(headers || {}) };
        if(requestBody){
          requestBody = await encrypt(JSON.stringify(requestBody), token);
          
        }
      }
    }
    return handleNetworkRequest(axios.put(addnewQueryParam(addSourceQueryParam(finalUrl)), requestBody, {
      headers: {
        ...headers,
        lob: getLob()
      },
      ...( localStorage.getItem("endToend") === "true" && { responseType: 'arraybuffer' })
    }));
}

export async function ChannelkartNetworkPatch(url: string, requestBody?: any, headers?: HttpHeaders): Promise<any> {
    const serverUrl = EnvironmentRegistry.getServerUrl();
    const finalUrl = url.startsWith("https") ? url : serverUrl + url;
    await checkAndRefreshTokenIfNeeded();
    const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
    const token = (await networkService.authState.getHttpEncryptionKey()) || sessionStorage.getItem("secureToken");
    if(localStorage.getItem("refreshToken") && sessionStorage.getItem("access_token")){
      headers = { Authorization: sessionStorage.getItem("access_token")!, ...headers}
      if (token && finalUrl.includes(serverUrl) && localStorage.getItem("endToend") === "true" && (!headers || headers["Content-Type"] !== "multipart/form-data")) {
        headers = { "Content-Type": "application/octet-stream", ...(headers || {}) };
        if(requestBody){
          requestBody = await encrypt(JSON.stringify(requestBody), token);
          
        }
      }
    }
    return handleNetworkRequest(axios.patch(addnewQueryParam(addSourceQueryParam(finalUrl)), requestBody, {
      headers: {
        ...headers,
        lob: getLob()
      },
      ...( localStorage.getItem("endToend") === "true" && { responseType: 'arraybuffer' })
    }));
}


export async function ChannelkartNetworkGet(url:string, requestBody?: any, headers?: HttpHeaders): Promise<any> {
    const serverUrl = EnvironmentRegistry.getServerUrl();
    const finalUrl = url.startsWith("https") ? url : serverUrl + url;
    await checkAndRefreshTokenIfNeeded();
    const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
    const token = (await networkService.authState.getHttpEncryptionKey())|| sessionStorage.getItem("secureToken");
    if(localStorage.getItem("refreshToken") && sessionStorage.getItem("access_token")){
      headers = { Authorization: sessionStorage.getItem("access_token")!, ...headers}
      if (token && finalUrl.includes(serverUrl) && localStorage.getItem("endToend") === "true" && (!headers || headers["Content-Type"] !== "multipart/form-data")) {
        
        headers = { "Content-Type": "application/octet-stream", ...(headers || {}) };
        if(requestBody){
          requestBody = await encrypt(JSON.stringify(requestBody), token);
          
        }
      }
    }
    // axios.get(url, {headers: {...headers,lob:getLob()});
    
    return handleNetworkRequest(axios.get(addnewQueryParam(addSourceQueryParam(finalUrl)), {
      params: requestBody, 
      headers: {
        ...headers,
        Lob: getLob()
      },
      ...( localStorage.getItem("endToend") === "true" && { responseType: 'arraybuffer' })
    }));
}

export async function ChannelkartNetworkDelete(url:string, requestBody?: any, headers?: HttpHeaders): Promise<any> {
    const serverUrl = EnvironmentRegistry.getServerUrl();
    const finalUrl = url.startsWith("https") ? url : serverUrl + url;
    await checkAndRefreshTokenIfNeeded();
    const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
    const token = (await networkService.authState.getHttpEncryptionKey())|| sessionStorage.getItem("secureToken");
    if(localStorage.getItem("refreshToken") && sessionStorage.getItem("access_token")){
      headers = { Authorization: sessionStorage.getItem("access_token")!, ...headers}
      if (token && finalUrl.includes(serverUrl) && localStorage.getItem("endToend") === "true" && (!headers || headers["Content-Type"] !== "multipart/form-data")) {
        headers = { "Content-Type": "application/octet-stream", ...(headers || {}) };
        if(requestBody){
          requestBody = await encrypt(JSON.stringify(requestBody), token);
          
        }
      }
    }
    return handleNetworkRequest(axios.delete(addnewQueryParam(addSourceQueryParam(finalUrl)), {
      headers: {
        ...headers,
        lob: getLob()
      },
      ...( localStorage.getItem("endToend") === "true" && { responseType: 'arraybuffer' })
    }));
}

export async function getJenkinsResponse() {
    const url ="/v1/jenkinsJobDetails/allJobs/false/true";
    const response =await ChannelkartNetworkGet(url);
    return response;
}

export function codemagicGetRequest(url: string) {
  return axios.get("https://api.codemagic.io" + url, {
    headers: {
      "x-auth-token": "ikSY7CpYMw6Fum3TIyNvdoENLDAkM7cNmHjwjDzE1_Q",
      "Content-Type": "application/json",
    },
  });
}

export function codemagicPostRequest(url: string, data?: any) {
  return axios.post("https://api.codemagic.io" + url, data, {
    headers: {
      "x-auth-token": "ikSY7CpYMw6Fum3TIyNvdoENLDAkM7cNmHjwjDzE1_Q",
      "Content-Type": "application/json",
    },
  });
}

export function envGetRequest(env:string,url:string, header?:any){
    const baseUrl = EnvironmentRegistry.getUrl(env);
    return axios.get(baseUrl + url,{
        headers:{
            'Content-Type': 'application/json',
            ...header
        }
    })

}
export const ChannelkartNetworkGetWithToken = async (api: string, token: string): Promise<any> => {
    const res = await ChannelkartNetworkGet(api, null, {
        Authorization: token,
    });
    return res;
};

export const ChannelkartNetworkPostWithToken = async (
  api: string,
  requestBody: any,
  token: string
): Promise<any> => {
  const res = await ChannelkartNetworkPost(api, requestBody, {
    Authorization: token,
  });
  return res;
};


export const sizeParam = 10000;

export function getNetworkServiceFunction(requestType: requestType){
  switch(requestType){
    case "GET": return ChannelkartNetworkGet;
    case "POST": return ChannelkartNetworkPost;
    case "PUT": return ChannelkartNetworkPut;
    case "DELETE": return ChannelkartNetworkDelete;
  }
}

export const META_DATA_BATCH_API = "/metadata/batch";
export const META_DATA_PLAYGROUND_API = "/metadata/playground";
